export var formatUserDate = function (date, locale) {
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' })
        .format(date)
        .replace(/ /g, '\xA0');
};
